import styled from 'styled-components';

import { FormContent } from '@dreryk/react-components';

const StyledP1IdentifierFormContent = styled(FormContent)`
   grid-template-columns: repeat(2, calc(50% - 5px));
   width: 100%;
   height: 6em;
`;
StyledP1IdentifierFormContent.displayName = 'StyledP1IdentifierFormContent';

export { StyledP1IdentifierFormContent };
